import { FC, MouseEventHandler, useEffect } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { useBuyerIncentivesMessages } from 'dibs-buyer-incentives/exports/useBuyerIncentivesMessages';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';
import { includes } from 'dibs-ts-utils/exports/includes';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

import dibsCss from 'dibs-css';

const AB_TEST_NAME = 'EBIv2_PM';

const Incentives: FC<{ showLink: boolean }> = ({ showLink }) => {
    const variant = getAbTestV2(AB_TEST_NAME)?.variant as
        | 'control'
        | 'variant-1'
        | 'variant-2'
        | 'variant-3'
        | undefined;
    const incentives = useBuyerIncentivesMessages({ variant });

    return (
        <>
            {incentives.map((incentive, index) => {
                let position = 'other';

                if (index === incentives.length - 1) {
                    position = showLink ? 'lastWithLink' : 'last';
                }

                return includes(['variant-1', 'variant-2', 'variant-3'], variant) ? (
                    <FormattedMessage
                        key={index}
                        id="PdpSharedSidebarBuyerIncentives.incentive"
                        defaultMessage="{position, select, last {{incentive}} lastWithLink {{incentive} } other {{incentive}, }}"
                        values={{ incentive, position }}
                    />
                ) : (
                    <div
                        key={index}
                        className={classnames(dibsCss.inlineBlock, dibsCss.whitespacePreWrap)}
                    >
                        <FormattedMessage
                            id="PdpSharedSidebarBuyerIncentives.incentive"
                            defaultMessage="{position, select, last {{incentive}} lastWithLink {{incentive} } other {{incentive}, }}"
                            values={{ incentive, position }}
                        />
                    </div>
                );
            })}
        </>
    );
};

const PdpSharedSidebarBuyerIncentives: FC<{
    onDetailsClick?: MouseEventHandler;
}> = ({ onDetailsClick }) => {
    const showLink = !!onDetailsClick;

    useEffect(() => {
        trackAbTestV2Variant(AB_TEST_NAME);
    }, []);

    return (
        <>
            {/* Render only on client side while this is in A/B test */}
            <ClientSuspense fallback={null}>
                <FormattedMessage
                    id="PdpSharedSidebarBuyerIncentives.incentives"
                    defaultMessage="<strong>The 1stDibs Promise:</strong> {incentives}<link>Details</link>"
                    values={{
                        strong: chunk => <strong>{chunk}</strong>,
                        incentives: <Incentives showLink={showLink} />,
                        link: chunk =>
                            showLink ? <Link onClick={onDetailsClick}>{chunk}</Link> : null,
                    }}
                />
            </ClientSuspense>
        </>
    );
};

export default PdpSharedSidebarBuyerIncentives;
